import Lottie from "lottie-react";
import styled from '@emotion/styled';
import { Theme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useContext, useState } from 'react';

import { DataContext } from 'providers/data';
import { DecodeToken } from 'utils/decodeToken';
import { SalesChannelEnum, ProfileVersionEnum } from 'utils/enums';
import { ParamsPageWebView } from 'utils/typeServices';
import { Box, Typography, Collapse } from '@mui/material';
import { ParsePerfilQuotation, ParseProfileVersion } from 'utils/parsePerfilQuotationAddServices';

import Modals from 'components/views/Modals';
import ParseWebView from 'components/views/ParseWebView';
import CarouselCars from 'components/views/CarouselCars';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';
import { ContentBodyPage, ContentNewsPage, Banner } from 'components/views/ContainersPage';

import loadingJson from 'assets/animation/loading_quotation.json';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';
import { ReactComponent as IcAdditionalServices } from 'assets/icons/ic-additional-services-logo.svg';
import BannerDadosAtualizadosDesk from 'assets/images/banners/desk/banner-dados-atualizados-desk.png';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

const AdditionalServices = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isFinish, setIsFinish] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [existActiveChanges, setExistActiveChanges] = useState(false);
    const [isLoadingCancelQuote, setIsLoadingCancelQuote] = useState(false);
    const [notExistActiveChanges, setNotExistActiveChanges] = useState(false);
    const [showModalExistActiveChanges, setShowModalExistActiveChanges] = useState(false);
    const [itemSelected, setItemSelected] = useState<{ cD_COTACAO: number, cD_PESSOA: number } | false>();
    const { selectedCar, dataPerfilUser, dataListaCotacaoAddService, dataPostCancelChange, dataCustomerForEdit, isPendingTicket, handleGetPerfilUser, handlePostCreateQuote, handleGetListaCotacaoAddService, handlePostCancelChange, handleGetInitialServices, handleGetCustomerForEdit, handlePostFinancialPending } = useContext(DataContext);

    const handlePostCreateQuoteState = () => {
        navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais/servicos`);
        const tokenDetailsAux = DecodeToken();

        if (selectedCar && dataCustomerForEdit) {
            handlePostCreateQuote({
                bodyLead: {
                    DS_EMAIL: selectedCar.EMAIL,
                    NM_LEAD: selectedCar.NOME_CLIENTE,
                    NR_TELEFONE: (tokenDetailsAux?.cellphone || '').replace(/[^0-9]/g, ''),
                    NM_URL_CRIACAO: window.location.host,
                    CD_PESSOA_PARCEIRO_CRIACAO: selectedCar.CD_PESSOA_PARCEIRO || 1783625,
                    CD_CANAL_VENDA_CRIACAO: SalesChannelEnum.TrocasAreaCliente,
                    JS_CONSENTIMENTO: {
                        optin: {
                            messaging: true,
                            voice: true,
                            email: false,
                            'social-media': false,
                        },
                    },
                },
                bodyQuote: {
                    DS_CHASSI: selectedCar.CHASSI,
                    DS_INSTALACAO: null,
                    NR_ANO: selectedCar.MODELO_ANO,
                    NR_ANO_FABRICACAO: null,
                    CD_TIPO_COMERCIALIZACAO: 2,
                    DS_PERFIL: dataPerfilUser ? ParsePerfilQuotation(dataPerfilUser) : null,
                    SISTEMA_ENUM: 16,
                    NR_TIPO_COTACAO: 7,
                    NR_CPF_CNPJ: selectedCar.NR_CNPJ_CPF,
                    DS_PLACA: selectedCar.PLACA,
                    NR_CEP_PERNOITE: `${dataPerfilUser ? dataPerfilUser?.CEP_PERNOITE : dataCustomerForEdit?.addressList[0].zipcode}`.replace(/[^0-9]/g, ''),
                    CD_LEAD: "",
                    CD_PESSOA_VENDEDOR: selectedCar.CD_PESSOA_VENDEDOR ? `${selectedCar.CD_PESSOA_VENDEDOR}` : null,
                    CD_PESSOA_RESPONSAVEL: `${selectedCar.CD_PESSOA}`,
                    CD_PESSOA_PARCEIRO: selectedCar.CD_PESSOA_PARCEIRO || 1783625,
                    CD_PESSOA_PARCEIRO_ESTABELECIMENTO: selectedCar.CD_PESSOA_PARCEIRO_ESTABELECIMENTO || 1783625,
                    CD_CANAL_VENDA: SalesChannelEnum.TrocasAreaCliente,
                    CD_CANAL_VENDA_PARCEIRO: null,
                    CD_MODELO: selectedCar.CD_MODELO,
                    CD_PESSOA_ORIGEM: selectedCar.CD_PESSOA,
                    NR_PLATAFORMA_ORIGEM: selectedCar.NR_PLATAFORMA,
                    DS_COR: selectedCar.COR || '',
                    DT_NASCIMENTO: dataCustomerForEdit.birthDate,
                    NR_VERSAO_PERFIL: dataPerfilUser ? ParseProfileVersion(dataPerfilUser) : ProfileVersionEnum.OldVersion
                },
                nrPlatform: selectedCar.NR_PLATAFORMA
            })
        }
    }

    const handlePostCancelChangeState = () => {
        setIsLoadingCancelQuote(true);

        if (itemSelected) {
            handlePostCancelChange(itemSelected);
        }
    }

    const handlePostFinancialPendingState = () => {
        if (selectedCar) {
            handlePostFinancialPending({
                token: localStorage.getItem('token')!,
                body: {
                    CPF_CNPJ: selectedCar?.NR_CNPJ_CPF,
                    ID_MOTIVO: 0,
                    DS_PLACA: selectedCar?.PLACA || null,
                    CD_PARCEIRO: 1783625,
                    FL_PAGAS: true
                }
            });
        }
    }

    useEffect(() => {
        if (typeof isPendingTicket === "undefined" && selectedCar) {
            handlePostFinancialPendingState();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPendingTicket, selectedCar]);

    const handleValidateIsOpenQuote = () => {
        setIsClicked(true);
        if (existActiveChanges && dataListaCotacaoAddService && selectedCar) {
            const selected = dataListaCotacaoAddService.find(({ NR_PLATAFORMA_ORIGEM, STATUS_PEDIDO_COTACAO, NR_TIPO_COTACAO }) => ((NR_PLATAFORMA_ORIGEM === selectedCar?.NR_PLATAFORMA) && (STATUS_PEDIDO_COTACAO <= 5) && (NR_TIPO_COTACAO === 7)));

            if (selected) {
                if (selected.STATUS_PEDIDO_COTACAO === 5) {
                    setIsFinish(true);
                } else {
                    setIsFinish(false);
                }

                setItemSelected({ cD_COTACAO: selected.CD_COTACAO, cD_PESSOA: selectedCar?.CD_PESSOA });
                setShowModalExistActiveChanges(true);
            } else {
                handlePostCreateQuoteState();
            }
        } else {
            handlePostCreateQuoteState();
        }
    }

    useEffect(() => {
        if (!dataCustomerForEdit) {
            handleGetCustomerForEdit({ token: localStorage.getItem('token')! });
        }

        if (typeof dataPerfilUser === "undefined" && selectedCar) {
            handleGetPerfilUser({ token: localStorage.getItem('token')!, nrPlatform: selectedCar.NR_PLATAFORMA });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPerfilUser, selectedCar]);

    useEffect(() => {
        if ((typeof dataListaCotacaoAddService === 'undefined') && selectedCar) {
            setIsLoading(true);
            handleGetListaCotacaoAddService(selectedCar.NR_CNPJ_CPF);
        }

        if (typeof dataListaCotacaoAddService !== 'undefined') {
            setIsLoading(false);

            if (dataListaCotacaoAddService && dataListaCotacaoAddService.length > 0) {
                const selected = dataListaCotacaoAddService.find(({ NR_PLATAFORMA_ORIGEM, STATUS_PEDIDO_COTACAO, NR_TIPO_COTACAO }) => ((STATUS_PEDIDO_COTACAO <= 5) && (NR_TIPO_COTACAO === 7)));
                if (selected) {
                    setExistActiveChanges(true);
                    setNotExistActiveChanges(false);
                } else {
                    setExistActiveChanges(false);
                    setNotExistActiveChanges(true);
                    setTimeout(() => {
                        setNotExistActiveChanges(false);
                    }, 3000);
                }
            } else {
                setExistActiveChanges(false);
                setNotExistActiveChanges(true);
                setTimeout(() => {
                    setNotExistActiveChanges(false);
                }, 3000);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListaCotacaoAddService, selectedCar]);

    useEffect(() => {
        if (dataPostCancelChange && isClicked) {
            handlePostCreateQuoteState();
        } else if (dataPostCancelChange === false) {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataPostCancelChange]);

    useEffect(() => {
        if (isWebView && location?.search.includes('token')) {
            localStorage.clear();
            handleGetInitialServices({ token: location?.search.split('=')[1], isWebView: true });
            localStorage.setItem('token', location?.search.split('=')[1]);
        } else if (isWebView && localStorage.getItem('token')) {
            handleGetInitialServices({ token: localStorage.getItem('token')!, isWebView: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ParseWebView title={isWebView ? '' : 'SERVIÇOS ADICIONAIS'} typePage='page' isWebView={isWebView}>
            <ContentBodyPage>
                <Box>
                    <Collapse in={(!isLoading && existActiveChanges)} {...((!isLoading && existActiveChanges) ? { timeout: 300 } : {})}>
                        <Box sx={{ cursor: 'pointer', maxWidth: '100%', alignItems: 'center', justifyContent: 'center', display: 'grid', gridTemplateColumns: { xs: 'auto 192px auto', md: '6.68rem 22rem auto' }, border: '1.23363px solid #10A7E0', padding: { xs: '0', md: '0 3.125rem' } }} onClick={() => navigate('contratacao-em-andamento')}>
                            <Box sx={{ 'svg': { width: { xs: '6rem', md: '6.68rem' } } }}>
                                <IcIturanCheck />
                            </Box>
                            <Box sx={{
                                padding: '1.3rem 0 1rem',
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px'
                            }}>
                                <Typography fontWeight={700} sx={{ fontSize: { xs: '1rem', md: '1.375rem' }, lineHeight: '1.2' }}>
                                    CONTRATAÇÃO EM ANDAMENTO!
                                </Typography>
                                <Typography fontWeight={600} paddingBottom='2px' sx={{ fontSize: { xs: '.75rem', md: '1.06rem' } }}>
                                    Continue já de onde parou.
                                </Typography>
                                <Typography fontWeight={700} sx={{ textDecoration: 'underline', fontSize: { xs: '.75rem', md: '1.06rem' } }}>
                                    Clique aqui
                                </Typography>
                            </Box>
                            <ArrowForwardIosIcon sx={{ margin: { xs: '0 .5rem 0 .5rem', md: '2rem' }, color: 'primary.light' }} />
                        </Box>
                    </Collapse>

                    <Collapse in={(!isLoading && notExistActiveChanges)} {...((!isLoading && notExistActiveChanges) ? { timeout: 300 } : {})}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '1.5rem', alignItems: 'center', border: '1.23363px solid #10A7E0' }}>
                            <Typography fontWeight={700} sx={{ fontSize: { xs: '1rem', md: '1.375rem' } }}>
                                Não há contratação em andamento!
                            </Typography>
                        </Box>
                    </Collapse>

                    <Collapse in={isLoading}>
                        <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column', height: '115px' }}>
                            <Typography fontSize='1.25rem' fontWeight={700} color='primary.light'>
                                Buscando contratação em andamento
                            </Typography>

                            <Box sx={{ marginTop: '5px', svg: { maxHeight: '90px' } }}>
                                <Lottie animationData={loadingJson} loop={true} />
                            </Box>
                        </Box>
                    </Collapse>
                </Box>

                <Box sx={{ marginTop: { xs: '1rem', md: '2.375rem' }, textAlign: 'center' }}>
                    <IcAdditionalServices />
                </Box>
                <Typography sx={{ textAlign: 'center', fontSize: { xs: '1.125rem', md: '1.25rem' }, margin: '1.2rem auto .5rem', lineHeight: '24px' }}>
                    <strong>Selecione o veículo</strong> que deseja <br /> adicionar serviços:
                </Typography>
                <CarouselCars />
                <Box sx={{ display: 'flex', paddingTop: '.5rem', justifyContent: 'center', 'button': { width: '100%', maxWidth: '17.5rem', height: '2.5rem' } }}>
                    <ButtonRectangle name='CONTINUAR' disabled={isLoading} onClick={() => handleValidateIsOpenQuote()} />
                </Box>
            </ContentBodyPage>
            <ContentNewsPage>
                <BoxBanner>
                    <Banner bannerImg={BannerDadosAtualizadosDesk} link='/meus-dados' />
                </BoxBanner>
            </ContentNewsPage>

            <Modals open={showModalExistActiveChanges}>
                <Box sx={{ borderRadius: '8px', textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '24rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700} lineHeight='30px'>
                            ATENÇÃO!
                        </Typography>
                        {isFinish ?
                            <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                                Identificamos que você já possui uma contratação <b>concluída.</b>
                            </Typography>
                            :
                            <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                                Identificamos que você já possui uma contratação em <b>andamento</b>, ao prosseguir com a nova contratação, a anterior será <b>cancelada.</b>
                            </Typography>
                        }
                    </Box>
                    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '0 0 8px 8px', padding: { xs: '1rem 2.5rem 1.625rem', md: '1rem 3.8125rem 1.625rem' }, 'button': { width: '100%' } }}>
                        {isFinish ?
                            <ButtonRectangle
                                name='VER CONTRATAÇÃO'
                                onClick={() => { setShowModalExistActiveChanges(false); navigate(`${isWebView ? '/wb' : ''}/servicos-adicionais/contratacao-em-andamento`); }}
                            />
                            :
                            <ButtonRectangle
                                name='CONTINUAR'
                                loadingBtn={isLoadingCancelQuote}
                                onClick={() => handlePostCancelChangeState()}
                            />
                        }
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined
                                name='FECHAR'
                                onClick={() => setShowModalExistActiveChanges(false)} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </ParseWebView>
    );
}


export default AdditionalServices;